import { useEffect, useState } from "react";
import { ResultsEntity } from "typings/Database/Results";
import Slide from "../Slide/Slide";
import styles from "./Slider.module.scss";
import ButtonAnimation from "components/UI/ButtonAnimation/ButtonAnimation";

export default function Slider({ slides }: { slides: ResultsEntity[] }) {
  const [currentPosition, setCurrentPosition] = useState(0);
  const numberOfSlides = slides.length;

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPosition((prev) => (prev + 1) % numberOfSlides);
    }, 10000);

    return () => clearTimeout(timer); // Opruimen van de timer bij ontkoppeling van het component
  }, [currentPosition, numberOfSlides]);

  return (
    <>
      <div className={styles.bottomButton}>
        <ButtonAnimation />
        <p>Start</p>
      </div>
      <div className={styles.slider}>
        <div
          style={{
            transform: `translate(-${(100 / numberOfSlides) * currentPosition}%, -50%)`,
          }}
          className={styles.slideRow}
        >
          {slides.map((slide, i) => {
            const isActive = i === currentPosition;
            return <Slide slide={slide} isActive={isActive} key={i} />;
          })}
        </div>
      </div>
    </>
  );
}
